function Bottom() {
  return (
    <div
      className={
        "fixed bottom-0 left-0 right-0 text-orange-500 text-center bg-orange-200  font-light text-md pt-1 md:text-2xl md:pt-2"
      }
    >
      created by
      <a
        href="https://iamrahul.dev"
        className="underline ml-2 text-lg md:text-2xl"
      >
        Rahul Dev
      </a>
      <p>© 2023 Rahul Dev. All right reserved.</p>
    </div>
  );
}
export default Bottom;
